export default [
    {
        path: '/rrhh/preingreso',
        name: 'rrhh-preingreso',
        component: () => import('@/views/pages/recursosHumanos/transacciones/datosGenerales/Preingreso.vue'),
        meta: {
            title: 'i18n:Preingreso',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-registro-preingreso',
            pageTitle: 'Datos Generales - Preingreso',
            breadcrumb: [
                {
                    text: 'Preingreso',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/transacciones/generar-permiso',
        name: 'rrhh-transacciones-generador-permisos',
        component: () => import('@/views/pages/recursosHumanos/transacciones/PermisoSalida.vue'),
        meta: {
            title: 'i18n:recursos_humanos.transacciones.generador_permisos.titulo',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-generador-permisos',
            pageTitle: 'recursos_humanos.transacciones.generador_permisos.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/atender-permiso',
        name: 'rrhh-transacciones-atencion-permisos',
        component: () => import('@/views/pages/recursosHumanos/informes/VisualizarPermisos.vue'),
        meta: {
            title: 'i18n:recursos_humanos.transacciones.atencion_permisos.titulo',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-atencion-permisos',
            pageTitle: 'recursos_humanos.transacciones.atencion_permisos.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    /*{
        path: '/rrhh/mantenimiento/tipos-permisos',
        name: 'rrhh-mantenimiento-tipos-permisos',
        component: () => import ('@/views/pages/recursosHumanos/mantenimiento/TiposPermisos.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-mantenimiento-tipos-permisos',
            pageTitle: 'Tipos de permisos',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                },
                {
                    text: 'manetenimiento',
                },
                {
                    text: 'Tipos de permisos',
                    active: true,
                },
            ],
        },
    },*/
    {
        path: '/rrhh/informes/personal-produccion',
        name: 'rrhh-personal-produccion',
        component: () => import('@/views/pages/recursosHumanos/informes/PersonalProduccion.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informes-personal-produccion',
            pageTitle: 'Informes',
            breadcrumb: [
                {
                    text: 'Personal Producción',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/reporte-permisos-empleados',
        name: 'rrhh-informe-permisos-empleados',
        component: () => import('@/views/pages/recursosHumanos/informes/InformePermisosEmpleados.vue'),
        meta: {
            title: 'i18n:recursos_humanos.informes.permisos_salida.titulo',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informes-permisos-empleados',
            pageTitle: 'recursos_humanos.informes.permisos_salida.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/transacciones/permisos-estudio',
        name: 'rrhh-transacciones-permisos-estudio',
        component: () => import('@/views/pages/recursosHumanos/transacciones/PermisosEstudio.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-permisos-estudio',
            pageTitle: 'Permisos de estudio',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Permisos de estudio',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/transacciones/memorandum',
        name: 'rrhh-transacciones-memorandum',
        component: () => import('@/views/pages/recursosHumanos/transacciones/Memorandum.vue'),
        meta: {
            title: 'i18n:recursos_humanos.transacciones.memorandum.titulo',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-memorandum',
            pageTitle: 'recursos_humanos.transacciones.memorandum.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/memorandums',
        name: 'rrhh-informe-memorandums',
        component: () => import('@/views/pages/recursosHumanos/informes/InformeMemorandums.vue'),
        meta: {
            title: 'i18n:recursos_humanos.informes.memorandum.titulo',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informes-memorandum',
            pageTitle: 'recursos_humanos.informes.memorandum.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Informes',
                    active: true,
                },
            ],
        },
    },
    // Eileen Sanchez
    {
        path: '/rrhh/transacciones/empresas-complementarios',
        name: 'rrhh-transacciones-empresas-complementarios',
        component: () => import('@/views/pages/recursosHumanos/transacciones/EmpresaComplementarios.vue'),
        meta: {
            title: 'i18n:recursos_humanos.transacciones.empresa_complementarios.title',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-empresas-complementarios',
            pageTitle: 'recursos_humanos.transacciones.empresa_complementarios.title',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/transacciones/empleados-complementarios',
        name: 'rrhh-transacciones-empleados-complementarios',
        component: () => import('@/views/pages/recursosHumanos/transacciones/DatosGeneralesComplementarios.vue'),
        meta: {
            title: 'i18n:recursos_humanos.transacciones.complementario.title',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-empleados-complementarios',
            pageTitle: 'recursos_humanos.transacciones.complementario.title',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/transacciones/lista-empleados-complementarios',
        name: 'rrhh-transacciones-lista-empleados-complementarios',
        component: () => import('@/views/pages/recursosHumanos/transacciones/ListadoComplementarios.vue'),
        meta: {
            title: 'i18n:recursos_humanos.transacciones.complementario.title_listado',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-lista-empleados-complementarios',
            pageTitle: 'recursos_humanos.transacciones.complementario.title_listado',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/transacciones/cargas-familiares-complementarios',
        name: 'rrhh-transacciones-cargas-familiares-complementarios',
        component: () => import('@/views/pages/recursosHumanos/transacciones/CargasFamiliares.vue'),
        meta: {
            title: 'i18n:recursos_humanos.transacciones.cargas_familiares.title',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-cargas-familiares-complementarios',
            pageTitle: 'recursos_humanos.transacciones.cargas_familiares.title',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/marcaciones-complementarios',
        name: 'rrhh-informe-marcaciones-complementarios',
        component: () => import('@/views/pages/recursosHumanos/informes/InformeMarcacionesComplementarios.vue'),
        meta: {
            title: 'i18n:recursos_humanos.informes.marcacion_complemantario.titulo',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informe-marcaciones-complementarios',
            pageTitle: 'recursos_humanos.informes.marcacion_complemantario.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/mracaciones-semanal',
        name: 'rrhh-informe-marcaciones-semanal',
        component: () => import('@/views/pages/recursosHumanos/informes/InformeEG.vue'),
        meta: {
            title: 'i18n:recursos_humanos.informes.marcacion_semanal.titulo',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informe-marcaciones-semanal',
            pageTitle: 'recursos_humanos.informes.marcacion_semanal.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/mantenimiento/examenes-medicos',
        name: 'rrhh-mantenimiento-examenes-medicos',
        component: () => import('@/views/pages/recursosHumanos/mantenimiento/ExamenesMedicos.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-mantenimiento-examenes-medicos',
            pageTitle: 'Examenes médicos',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                },
                {
                    text: 'mantenimiento',
                },
                {
                    text: 'Examenes médicos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/mantenimiento/examenes-por-seccion',
        name: 'rrhh-mantenimiento-examenes-por-seccion',
        component: () => import('@/views/pages/recursosHumanos/mantenimiento/ExamenesPorSeccion.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-mantenimiento-examenes-por-seccion',
            pageTitle: 'Examenes médicos por sección',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                },
                {
                    text: 'mantenimiento',
                },
                {
                    text: 'Examenes por seccion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/transacciones/planes-claro',
        name: 'rrhh-transacciones-planes-claro',
        component: () => import('@/views/pages/recursosHumanos/transacciones/PlanesClaro.vue'),
        meta: {
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-transacciones-planes-claro',
            pageTitle: 'Administración planes claro',
            breadcrumb: [
                {
                    text: 'RRHH',
                    active: true,
                },
                {
                    text: 'transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/correo-institucional',
        name: 'rrhh-informe-correo-institucional',
        component: () => import('@/views/pages/recursosHumanos/informes/CorreoInstitucional.vue'),
        meta: {
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informe-correo-institucional',
            pageTitle: 'recursos_humanos.informes.correo_institucional.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/encuestas',
        name: 'rrhh-informe-encuestas',
        component: () => import('@/views/pages/recursosHumanos/informes/Encuestas.vue'),
        meta: {
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informe-encuestas',
            pageTitle: 'recursos_humanos.informes.encuestas.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/configuracion/permisos-salida',
        name: 'rrhh-configuracion-permisos-salida',
        component: () => import('@/views/pages/recursosHumanos/configuracion/PermisosSalida.vue'),
        meta: {
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-configuracion-permisos-salida',
            pageTitle: 'recursos_humanos.configuracion.permisos_salida.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/configuracion/permisos-fabrica',
        name: 'rrhh-configuracion-permisos-fabrica',
        component: () => import('@/views/pages/recursosHumanos/configuracion/PermisosFabrica.vue'),
        meta: {
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-configuracion-permisos-fabrica',
            pageTitle: 'recursos_humanos.configuracion.permisos_fabrica.titulo',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/mantenimiento/somos-santa-priscila',
        name: 'rrhh-mantenimiento-somos-santa-priscila',
        component: () => import('@/views/pages/recursosHumanos/mantenimiento/SomosSantaPriscila.vue'),
        meta: {
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-mantenimiento-somos-santa-priscila',
            pageTitle: 'recursos_humanos.mantenimiento.somos_santa_priscila',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rrhh/informes/panel-indicadores',
        name: 'rrhh-informes-panel-indicador',
        component: () => import('@/views/pages/recursosHumanos/informes/PanelIndicadores.vue'),
        meta: {
            resource: 'Recursos Humanos',
            action: 'ver-rrhh-informes-panel-indicador',
            pageTitle: 'Panel de indicadores',
            breadcrumb: [
                {
                    text: 'recursos_humanos.titulo',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
            ],
        },
    },
]
